import { ReactNode, useState } from 'react'
import { CloseButton } from './CloseButton'
import { CallbackFn, useOverlayVisibility } from './Overlay'
import { SlidingTransition } from './SlidingTransition'

export const FullScreenOverlay = ({
  children,
  onClose,
}: {
  children: ReactNode
  onClose?: CallbackFn
}) => {
  const { setOpen, windowContentRef } = useOverlayVisibility()
  const [inProp, setInProp] = useState(true)

  return (
    <div className=" h-screen">
      <SlidingTransition
        inProp={inProp}
        onExit={() => {
          setOpen(false)
        }}
      >
        <div ref={windowContentRef} className="w-screen h-screen p-4 bg-white overflow-x-hidden">
          <div className="mb-8">
            <div className="flex justify-end">
              <CloseButton
                onClose={() => {
                  if (onClose) {
                    onClose(() => setInProp(false))
                  } else {
                    setInProp(false)
                  }
                }}
              />
            </div>
            <div className="bg-white w-screen overflow-y-scroll">{children}</div>
          </div>
        </div>
      </SlidingTransition>
    </div>
  )
}
